import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { cn } from '@/lib/utils';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'Doubt Clearing', path: '/doubt-clearing' },
  { label: 'Career Counselling', path: '/career-counselling' },
];

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => { setMobileOpen(false); }, [location.pathname]);

  return (
    <header
      data-testid="main-header"
      className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm border-b border-gray-100"
    >
      <div className="container mx-auto px-6 lg:px-16">
        <div className="flex items-center justify-between h-24">
          <Link to="/" data-testid="logo-link" className="flex items-center">
            <img
              src="https://customer-assets.emergentagent.com/job_planet-gyaan-edu/artifacts/no8w3qt3_Untitled%20design-73.png"
              alt="Planet Gyaan"
              className="h-14 md:h-16 w-auto"
            />
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map(link => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-${link.path === '/' ? 'home' : link.path.slice(1)}`}
                className={cn(
                  'font-body font-medium transition-colors text-sm',
                  location.pathname === link.path
                    ? 'text-[#E9811F] font-bold'
                    : 'text-[#52525B] hover:text-[#121212]'
                )}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-4">
            <a
              href="tel:+919930010800"
              data-testid="header-call-cta"
              className="hidden md:flex items-center gap-2 bg-[#F2C402] text-[#0A0A0A] px-5 py-2.5 rounded-xl font-bold text-sm hover:bg-[#E9811F] hover:text-white transition-all"
            >
              <Phone className="w-4 h-4" /> Call Now
            </a>
            <button
              data-testid="mobile-menu-toggle"
              className="md:hidden"
              onClick={() => setMobileOpen(!mobileOpen)}
            >
              {mobileOpen
                ? <X className="w-6 h-6 text-[#121212]" />
                : <Menu className="w-6 h-6 text-[#121212]" />
              }
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div data-testid="mobile-menu" className="md:hidden bg-white rounded-2xl shadow-lg p-6 mb-4 border-2 border-[#121212]">
            {navLinks.map(link => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`mobile-nav-${link.path === '/' ? 'home' : link.path.slice(1)}`}
                className={cn(
                  'block py-3 font-body font-medium text-base border-b border-gray-100 last:border-0',
                  location.pathname === link.path ? 'text-[#F2C402]' : 'text-[#121212]'
                )}
              >
                {link.label}
              </Link>
            ))}
            <div className="flex gap-3 mt-4 pt-4 border-t border-gray-200">
              <a href="https://wa.me/919930010800" data-testid="mobile-whatsapp-cta" className="flex-1 bg-[#25D366] text-white px-4 py-3 rounded-xl font-bold text-sm text-center">WhatsApp</a>
              <a href="tel:+919930010800" data-testid="mobile-call-cta" className="flex-1 bg-[#F2C402] text-[#0A0A0A] px-4 py-3 rounded-xl font-bold text-sm text-center">Call Now</a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
